import { transparentize } from 'polished'
import styled from 'styled-components'

type Props = {
	hasError: boolean
	shouldFill?: boolean
	shouldShrink?: boolean
}

export const InputComponent = styled.input<Props>`
	background-color: transparent;
	border: none;
	color: currentColor;
	font-family: ${({ theme }) => theme.font.family.base};
	font-size: 14px;
	-webkit-tap-highlight-color: transparent;
	display: block;
	width: ${({ shouldFill = true, shouldShrink = false }) => {
		if (shouldShrink) return '5px' // It will still render the caret at this size
		return shouldFill ? '100%' : 'max-content'
	}};
	min-height: 22px;

	&:focus {
		outline: none;
	}

	&::placeholder {
		color: ${({ hasError, theme }) => (hasError ? transparentize(0.65, theme.color.input.textFaded) : theme.color.input.textPlaceholder)};
	}
`
